<template>
  <div id='PageHeader' :class="$style.PageHeader">
    <Menu
      mode="horizontal"
      theme="primary"
      :active-name="activeName"
      ref="headerMenu"
      breakpoint='xs'
      @on-select="$_openPage">
      <div :class="$style.logo"><img :src="logo"/></div>
      <div :class="$style.title">{{title}}</div>
      <div :class="$style.menu">
        <span
          v-for="(item, index) in menuItems"
          :key="item.id">
          <!-- has sub -->
          <Submenu
            v-if="item.children!=null&&item.children.length>0"
            :name="item.id">
            <template slot="title">
              <Icon :type="item.icon"></Icon>
              <!-- {{item.text}} -->
            </template>
            <MenuItem
              v-for="(subItem) in item.children"
              :key="subItem.id"
              :name="subItem.id">
              {{subItem.text}}
            </MenuItem>
          </Submenu>
          <!-- no sub -->
          <MenuItem
            v-else
            :key="index"
            :name="item.id">
            <Icon :type="item.icon"></Icon>
            {{item.text}}
          </MenuItem>
        </span>
      </div>
    </Menu>
    <Modal
      title="About"
      cancel-text=""
      v-model="displayAbout"
      class-name="vertical-center-modal"
      @on-visible-change="$_closeAbout">
      <p>Made by darkzero</p>
      <a href="http://darkzero.me" target="_blank">darkzero.me</a>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  data () {
    return {
      logo: require('../assets/icon_180.png'),
      title: 'Topeko',
      displayAbout: false,
      activeName: '',
      menuItems: [
        // {
        //   text: 'Home',
        //   id: 'home',
        //   url: '/',
        //   icon: 'home',
        //   isActive: true
        // },
        {
          text: 'About',
          id: 'about',
          url: '/about',
          icon: 'information-circled'
        }
      ],
      menuUrl: {
        // home
        'home': '/',
        // about
        'about': '/about'
      }
    }
  },
  methods: {
    $_openPage: function (name) {
      this.displayAbout = true
    },
    $_closeAbout: function (display) {
      this.activeName = display ? 'about' : ''
    },
    $_openSubMenu: function (name) {
      console.log('click: ' + name)
      var url = this.menuUrl[name]
      this.$router.push(url)
    }
  }
}
</script>

<style module>
  .PageHeader {
    left: 0px;
    position: fixed;
    width: 100%;
    z-index: 9999;
  }

  div.logo {
      width: 100px;
      height: 100%;
      border-radius: 0px;
      float: left;
      position: relative;
      top: 0px;
      left: -20px;
  }

  div.logo img {
    width: 60px;
    height: 60px;
  }

  div.title {
    height: 40px;
    line-height: 40px;
    font-size: 16pt;
    font-weight: bold;
    text-align: center;
    color: #fff;
    /*background: #f95;*/
    border-radius: 8px;
    float: left;
    position: relative;
    top: 10px;
    left: 30px;
    padding: 0px 20px 0px 20px
  }

  .menu{
      width: 120px;
      margin: 0 auto;
      margin-right: 0px;
      right: 0px;
  }

  .headerMenu {
    position: relative;
    height: 100%;
    right: 0px;
    /*padding-right: 10px;*/
    margin-right: 0px;
  }

  img.logo {
    display: inline-block;
    width: 64px;
    height: 100%;
  }
</style>
<style lang="less">
    .vertical-center-modal{
        display: flex;
        align-items: center;
        justify-content: center;

        .ivu-modal{
            top: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/PageHeader.vue